import { useCallback, useState } from 'react'
import _ from 'lodash'
import { copyVariation } from './utils'

export default ({ tabs, model, defaultVariation }) => {

  const { onChange, values } = model

  const [currentTab, setCurrentTab] = useState((tabs[0] || {}).value)
  const [addNew, setAddNew] = useState(false)
  const [edit, setEdit] = useState(false)

  const handleTabChange = setCurrentTab
  const handleAdd = useCallback(() => {
    setAddNew(true)
  }, [])

  const handleEdit = useCallback(() => {
    setEdit(true)
  }, [])

  const handleCreate = useCallback(({ translates, variation, variationIndex })  => {
    onChange({
      target: {
        name: 'values',
        value: [...values, {
          ...( variation ? copyVariation(variation) : JSON.parse(JSON.stringify(defaultVariation))),
          translates,
        }],
      },
    }, (modelToChange, { copyErrors }) => {
      if (variation) {
        return copyErrors(modelToChange, `values[${variationIndex}]`, `values[${values.length}]` )
      }
      return modelToChange
    })
    setCurrentTab(`${tabs.length}`)
    setAddNew(false)
  }, [defaultVariation,  onChange, tabs.length, values])

  const handleRename = useCallback(translates => {
    onChange({
      target: {
        name: `values.[${currentTab}].translates`,
        value: translates,
      },
    })
    setEdit(false)
  }, [currentTab, onChange])


  const [itemToDelete, setShowDeleteModal] = useState(null)

  const handleDelete = useCallback(variantIndex => {
    setShowDeleteModal(variantIndex)
  }, [])

  const onDelete = useCallback(() => {
    const item = _.get(model, `values[${itemToDelete}]`)
    onChange({
      target: {
        name: 'values',
        value: values.filter(value => value !== item),
      },
    }, (model, modifyUtils) => modifyUtils.correctErrorsAfterDeleteItem(model, 'values', itemToDelete))
    setCurrentTab(`${Math.min(values.length - 2, currentTab)}`)
    setShowDeleteModal(false)
  }, [currentTab, itemToDelete, model, onChange, values])

  return {
    currentTab,
    handleTabChange,
    handleAdd,
    handleEdit,
    addNew,
    edit,
    setAddNew,
    setEdit,
    handleCreate,
    handleRename,
    handleDelete,
    itemToDelete,
    setShowDeleteModal,
    onDelete,
    setCurrentTab,
  }
}
